<div class="strength-indicator card-health-monitor m-05">
  @if (title) {
    <div class="text ellipsis mb-1">
      {{ title }}
    </div>
  }
  <div class="mb-1">
    <div class="d-flex justify-content-end">
      @if (showValue) {
        <div class="pr-05">
          @if (value !== null) {
            <div>{{ value }}{{ suffix }}</div>
          }
        </div>
      }
      @if (icon === 'network') {
        <div class="svg">
          @if (!score) {
            <mat-icon svgIcon="{{ icon }}-0"></mat-icon>
          } @else {
            <mat-icon [svgIcon]="icon + '-' + (scoreValue >= 4 ? '4' : scoreValue)"></mat-icon>
          }
        </div>
      }
      @if (icon === 'circle') {
        <div class="svg">
          @if (scoreBoolean) {
            <div>
              <mat-icon class="green-color">check_circle_outline</mat-icon>
            </div>
          } @else {
            <mat-icon class="red-color">highlight_off</mat-icon>
          }
        </div>
      }
    </div>
    @if (targetPeriodMs) {
      <div class="value-wrapper ellipsis value d-flex justify-content-end">
        Target period: {{ targetPeriodMs }}{{ suffix }}
      </div>
    }
    @if (maximumMs) {
      <div class="value-wrapper ellipsis value d-flex justify-content-end">
        {{ 'touareg.maxDelay' | translate }}: {{ maximumMs }}{{ suffix }}
      </div>
    }
    @if (score) {
      <div class="average">
        <span>{{ 'touareg.average' | translate }}</span
        >&nbsp;@if (averageLength) {
          <span>({{ 'touareg.last' | translate }} {{ averageLength }} {{ 'touareg.measures' | translate }})</span>
        }&nbsp;: {{ score.average }}{{ suffix }}
      </div>
    }
  </div>
  @if (description) {
    <div>{{ description }}</div>
  }
</div>
